const tutorialVideos = [
  {
    id: "0",
    src:
    {
      en: "/vids/tutorials_fr/createAccount_fr.mp4",
      fr: "/vids/tutorials_fr/createAccount_fr.mp4",
      nl: "/vids/tutorials_nl/createAccount_nl.mp4"
    },
    title: {
      en: "Create an account",
      nl: "Account aanmaken",
      fr: "Créer un compte"
    }
  },
  {
    id: "2",
    src:
    {
      en: "/vids/tutorials_fr/TypeD_fr.mp4",
      fr: "/vids/tutorials_fr/TypeD_fr.mp4",
      nl: "/vids/tutorials_nl/TypeD_nl.mp4"
    },
    title: {
      en: "Create a one day road occupancy : Type D",
      nl: "Een nieuwe openbare weg bezetting van max 1 dag aanmaken : Type UV",
      fr: "Créer une occupation de la voirie d'une journée : Type D"
    }
  },
  {
    id: "3",
    src:
    {
      en: "/vids/tutorials_fr/TypeE_fr.mp4",
      fr: "/vids/tutorials_fr/TypeE_fr.mp4",
      nl: "/vids/tutorials_nl/TypeE_nl.mp4"
    },
    title: {
      en: "Create a road occupancy + Send the declaration of execution : Type E",
      nl: "Maak een nieuwe openbare weg bezetting aan + Bouwplaatsaanvraag versturen: Type U",
      fr: "Créer une occupation de la voirie + Envoyer une déclaration d'exécution : Type E"
    }
  },
  {
    id: "4",
    src:
    {
      en: "/vids/tutorials_fr/avisDem_fr.mp4",
      fr: "/vids/tutorials_fr/avisDem_fr.mp4",
      nl: "/vids/tutorials_nl/avisDem_nl.mp4"
    },
    title: {
      en: "Send a start of works notice : Type A",
      nl: "Bericht van opstarting doorsturen : Type V",
      fr: "Envoyer un avis de démarrage : Type A"
    }
  },
  {
    id: "5",
    src:
    {
      en: "/vids/tutorials_fr/FlashMsg_fr.mp4",
      fr: "/vids/tutorials_fr/FlashMsg_fr.mp4",
      nl: "/vids/tutorials_nl/FlashMsg_nl.mp4"
    },
    title: {
      en: "Send a flash notice",
      nl: "Een flash bericht doorsturen",
      fr: "Envoyer un avis flash"
    }
  },
  {
    id: "6",
    src:
    {
      en: "/vids/tutorials_fr/MobCut_fr.mp4",
      fr: "/vids/tutorials_fr/MobCut_fr.mp4",
      nl: "/vids/tutorials_nl/MobCut_nl.mp4"
    },
    title: {
      en: "Create a mobility cross-section",
      nl: "Maak een mobiliteitsdoorsneden",
      fr: "Créer une coupe de mobilité"
    }
  },


];

export default tutorialVideos;

// A été supprimé car n'a pas été actualisé suite à la release 3.66
/* {
  id: "4",
  src:
  {
    en: "/vids/tutorials_fr/DrawSite_fr.mp4",
    fr: "/vids/tutorials_fr/DrawSite_fr.mp4",
    nl: "/vids/tutorials_nl/DrawSite_nl.mp4"
  },
  title: {
    en: "How to draw a road occupancy footprint?",
    nl: "De omvang van een openbare weg bezetting tekenen",
    fr: "Comment dessiner l'emprise d'une occupation de voirie?"
  }
},*/